import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class CustomerOrdersSummary extends Component {
  renderFuel(item) {
    return (
      <div className="oil-fuel-item">
        <h5>{item.name}</h5>
        <span>{item.total.toFixed(1)} gal</span>
      </div>
    );
  }

  renderOil(item) {
    return (
      <div className="oil-fuel-item">
        <h5>{item.name}</h5>
        <span>{item.total.toFixed(1)} quarts</span>
      </div>
    );
  }

  render() {
    const { summary } = this.props;
    return (
      <article className="order-summary">
        <h2>Summary for Tail Number: {summary.tailNumber}</h2>
        <div className="fuel-orders-summary">
          <h4 className="oil-fuel-header">Fuels</h4>
          {summary.fuelTotals && Object.values(summary.fuelTotals).map(item => this.renderFuel(item))}
          <div className="clear" />
        </div>
        <div className="oil-orders-summary">
          <h4 className="oil-fuel-header">Oils</h4>
          {summary.oilTotals && Object.values(summary.oilTotals).map(item => this.renderOil(item))}
          <div className="clear" />
        </div>
        <div className="customer-names">{summary.customerNames ? summary.customerNames.join(', ') : ''}</div>
        <div className="clear" />
      </article>
    );
  }
}

CustomerOrdersSummary.propTypes = {
  summary: PropTypes.object.isRequired,
};




// WEBPACK FOOTER //
// ./src/Containers/Reports/CustomerOrders/CustomerOrdersSummary.js